function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    //facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.filterTags();
    this.filterPrices();
    this.renderFilter();
    this.sortEvents();
    this.renderPaginate();
    this.eventFacetsRemove();
    this.renderFacetsRemove(window.location.href);

    const page_bottom = document.querySelector('.toolbar-bottom');
    let total_count;
    let total_count_element = document.querySelector('.product-total-count');
    let total_count_title_element = document.querySelector('.product-total-title-count');
    let mobile_total = document.querySelector('#ProductCount');
    if (page_bottom) {
      total_count = page_bottom.querySelector('.page-total-count').innerHTML;
      total_count_element.innerHTML = total_count;
      total_count_title_element ? (total_count_title_element.innerHTML = total_count) : null;
      mobile_total.innerHTML = `${total_count} Products`;
    } else {
      const product_items = document.querySelectorAll('.grid-item');
      total_count_element.innerHTML = product_items.length;
      total_count_title_element ? (total_count_title_element.innerHTML = product_items.length) : null;
      mobile_total.innerHTML = `${product_items.length} Products`;
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }


  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        // FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        // FacetFiltersForm.renderFilters(html, event);
        // FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  
    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    let additional_url = '';
    const inputs = document.querySelectorAll('[js-facet-checkbox] input');
    inputs.forEach(item => {
      if (item.checked) {
        const type = item.name;
        const value = item.value.replace('&', '%26').replace(' ', '+');
        if (!searchParams.includes(value))
          additional_url += type + '=' + value.replace('&', '%26').replace(' ', '+') + '&';
      }
    });

    if (additional_url != '')
      searchParams += `&${additional_url}`;
    
    FacetFiltersForm.renderPage(searchParams, event);
  } 

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  sortEvents() {
    const sortElement = this.querySelector('[js-filter-sort]');
    if (sortElement) {
      sortElement.addEventListener('change', (e) => {
        e.preventDefault();

        this.sortFunc(e.target.value);
        //this.sortFunc();
      })
    }

    const sortButton = this.querySelector('[js-sort-button]');
    const sortList = this.querySelector('[js-sort-list]');
    const sortItems = sortList.querySelectorAll('li');

    if (sortButton) {
      sortButton.addEventListener('click', (e) => {
        e.preventDefault();

        if (sortList) {
          if (sortList.classList.contains('hidden')) {
            sortList.classList.remove('hidden');
          } else {
            sortList.classList.add('hidden');
          }
        }
      });
    }

    sortItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        sortElement.value = item.getAttribute('data-value');
        this.sortFunc(item.getAttribute('data-value'));

        sortItems.forEach(rmItem => {
          rmItem.classList.remove('active');
        });

        item.classList.add('active');

        const sortActiveLabel = document.querySelector('[js-sort-active-label]');
        if (sortActiveLabel) {
          sortActiveLabel.innerHTML = item.getAttribute('data-title');
          sortList.classList.add('hidden');
        }
      });
    });
  }

  sortFunc (sort_value) {
    let filter_str = '', url = '';
    const w_url = window.location.href;
    if (w_url.split('?').length > 0) {
      let filter_strs = w_url.split('?')[1];

      if (sort_value) {
        const sort_param = 'sort_by';
        const sort_val = sort_value;  

        let is_sort = false;

        if (filter_strs && filter_strs.includes('&') && filter_strs.includes('filter.')) {
          let fiter_arrs = filter_strs.split('&');
          fiter_arrs.forEach(filter => {
            if (filter != '') {
              const param_name = filter.split('=')[0];
              const value = filter.split('=')[1];
              if (param_name == 'sort_by') {
                is_sort = true;
                filter_str += `${sort_param}=${sort_val}&`
              } else {
                filter_str += `${param_name}=${value}&`
              }
            }
          });
        }

        if (!is_sort) {
          filter_str += `${sort_param}=${sort_val}&`;
        }

        url = `${window.location.pathname}?${filter_str}`;

        let template_val = 'collection';
        const template = document.querySelector('.facets-container');
        if (template) template_val = template.getAttribute('data-template');
    
        if (!template_val.includes('collection')) {
          url += `type=product&q=${template.getAttribute('data-search')}&`; 
        }

        fetch(`${url}view=json`).then(res => {
          return res.text();
        }).then(text => {
          window.history.pushState(null,"",url);

          let cHtml = '';
      
          if (template_val.includes('collection')) {
            cHtml = document.getElementById('ProductGridContainer');
          } else {
            cHtml = document.getElementById('MainSearchContainer');
          }

          if (cHtml) {
            cHtml.innerHTML = text;

            var api = new Yotpo.API(yotpo);
            api.refreshWidgets();
          }

          const mobileFilterClose = document.querySelector('[js-active-filter]');
          if (mobileFilterClose) {
            mobileFilterClose.click();
          }
        }).finally(() => {
          document.dispatchEvent(new Event('EXCHANGE-RATES:REFRESH'));
        });
      }
    }
  }

  filterPrices () {
    const min_price = this.querySelector('[js-filter-min-price]');
    const max_price = this.querySelector('[js-filter-max-price]');

    if (min_price && max_price) {
      min_price.addEventListener('change', (e) => {
        e.preventDefault();

        const min_value = min_price.value;
        const min_param = min_price.name;

        const max_value = max_price.value;
        const max_param = max_price.name;

        let result = [
          {
            id: min_param,
            value: min_value 
          },
          {
            id: max_param,
            value: max_value
          }
        ]

        this.renderNewCollection(result, true);
      });

      max_price.addEventListener('change', (e) => {
        e.preventDefault();

        const min_value = min_price.value;
        const min_param = min_price.name;

        const max_value = max_price.value;
        const max_param = max_price.name;

        let result = [
          {
            id: min_param,
            value: min_value 
          },
          {
            id: max_param,
            value: max_value
          }
        ]

        this.renderNewCollection(result, true);
      });
    }
  }

  filterTags () {
    const filterButtons = document.querySelectorAll('[js-filter-button]');
    const filterContent = document.querySelectorAll('[js-filter-content]');
    const filterItems = document.querySelectorAll('[js-filter-item]');
  
    filterButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (button.classList.contains('active')) {
          button.classList.remove('active');

          const val = button.getAttribute('data-value');
          filterContent.forEach(content => {
            var content_val = content.getAttribute('data-value');
            if (val == content_val) {
              content.classList.add('hidden');
            }
          });
        } else {
          button.classList.add('active');
          const val = button.getAttribute('data-value');

          filterContent.forEach(content => {
            var content_val = content.getAttribute('data-value');
            if (val == content_val) {
              content.classList.remove('hidden');
            }
          });
        }
      });
    });
  
    filterItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const input = item.querySelector('input');
        input.checked = !input.checked;
        this.updateParams();
      });
    });
  }

  updateParams () {
    const all_inputs = this.querySelectorAll('[js-filter-item]');
    let arr = [];
    all_inputs.forEach(element => {
      const input = element.querySelector('input');
      let option = {
        id: input.name,
        value: input.value
      }
      if (input.checked) {
        arr.push(option);
      }
    });
    this.renderNewCollection(arr, false);
  }

  renderFilter() {
    const url = window.location.href;

    if (url.split('?').length > 0) {
      let filter_strs = url.split('?')[1];

      if (filter_strs && filter_strs.includes('&') && filter_strs.includes('filter.')) {
        let filters = filter_strs.split('&');
        filters.forEach(filter => {
          if (filter != '') {
            const param_name = filter.split('=')[0];
            const value = filter.split('=')[1];

            const filterItems = document.querySelectorAll('[js-filter-item]');
            filterItems.forEach(item => {
              const input = item.querySelector('input');
              if (input.value == value && input.name == param_name) {
                input.checked = true;

                const activeContent = item.parentNode;
                activeContent.classList.remove('hidden');
                const activeButton = activeContent.parentNode.querySelector('[js-filter-button]');
                activeButton.classList.add('active');
              }
            });
          }
        });
      }
    }
  }

  renderPaginate() {
    const pageLinks = document.querySelectorAll('[js-page-link]');
    const prevButton = document.querySelector('[js-prev-page]');
    const nextButton = document.querySelector('[js-next-page]');
    
    pageLinks.forEach(link => {
      console.log('[renderPaginate] Full URL:', link.getAttribute('data-url'));
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const fullUrl = link.getAttribute('data-url');
        const template = link.getAttribute('data-template') || 'collection';
        console.log('[renderPaginate] Full URL:', fullUrl);

         if (fullUrl) {
           window.location.href = fullUrl;
        } else {
            const page_url = `page=${link.getAttribute('data-page')}`;
            this.addPage(page_url);
        }
      });
    });
    
    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        const fullUrl = prevButton.getAttribute('data-url');
        const template = prevButton.getAttribute('data-template') || 'collection';
        if (fullUrl) {
          window.location.href = fullUrl;
        } else {
          const page_url = `page=${prevButton.getAttribute('data-page')}`;
          this.addPage(page_url);
        }
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        const fullUrl = nextButton.getAttribute('data-url');
        const template = nextButton.getAttribute('data-template') || 'collection';
        if (fullUrl) {
          window.location.href = fullUrl;
        } else {        
          const page_url = `page=${nextButton.getAttribute('data-page')}`;
          this.addPage(page_url);
        }
      });
    }
  }

  addPage (link) {
    const url = window.location.href;
    const prefix_url = url.split('?')[0];
    let result_url = '';

    if (url.includes('?') && url.split('?').length > 0) {  
      const filter_items = url.split('?')[1].split('&');
      filter_items.forEach(item => {
        if (item != '') {
          const param = item.split('=')[0];
          const value = item.split('=')[1];

          if (param == 'page') {
            result_url += `${link}&`;
          } else {
            if (param != 'view')
              result_url += `${param}=${value}&`;
          }
        }
      });

      if (!url.includes('page=')) {
        result_url += `${link}&`;
      }
    } else {
      result_url += `${link}&`;
    }
    
    window.location.href = `${prefix_url}?${result_url}`;
  }

  renderNewCollection(filters , is_price) {
    let filter_str = '', url = '';
    if (!is_price) {
      filters.forEach(filter => {
        filter_str += `${filter.id}=${filter.value}&`
      });

      const min_price = this.querySelector('[js-filter-min-price]');
      const max_price = this.querySelector('[js-filter-max-price]');
      if (min_price && max_price)
        url = `${window.location.pathname}?${filter_str}filter.v.price.gte=${min_price.value}&filter.v.price.lte=${max_price.value}&`;
      else
        url = `${window.location.pathname}?${filter_str}`;
    } else {
      const w_url = window.location.href;
      if (w_url.split('?').length > 0) {
        let filter_strs = w_url.split('?')[1];
  
        if (filter_strs && filter_strs.includes('&') && filter_strs.includes('filter.')) {
          let fiter_arrs = filter_strs.split('&');
          fiter_arrs.forEach(filter => {
            if (filter != '') {
              const param_name = filter.split('=')[0];
              const value = filter.split('=')[1];

              if (param_name == 'filter.v.price.lte' || param_name == 'filter.v.price.gte') {
                filters.forEach(item => {
                  if (item.id == param_name) {
                    filter_str += `${item.id}=${item.value}&`
                  }
                });
              } else {
                filter_str += `${param_name}=${value}&`
              }
            }
          });
        }

        if (!filter_str.includes('filter.v.price')) {
          const min_price = this.querySelector('[js-filter-min-price]');
          const max_price = this.querySelector('[js-filter-max-price]');
          url = `${window.location.pathname}?${filter_str}filter.v.price.gte=${min_price.value}&filter.v.price.lte=${max_price.value}&`;
        } else {
          url = `${window.location.pathname}?${filter_str}`;
        }
      }
    }

    const sortElement = document.querySelector('[js-filter-sort]');
    const sort_param = sortElement.name;
    const sort_val = sortElement.value;

    url += `${sort_param}=${sort_val}&`

    let template_val = 'collection';
    const template = document.querySelector('.facets-container');
    if (template) template_val = template.getAttribute('data-template');

    if (!template_val.includes('collection')) {
      url += `type=product&q=${template.getAttribute('data-search')}&`; 
    }
    
    fetch(`${url}view=json`).then(res => {
      return res.text();
    }).then(text => {
      let cHtml = '';
      
      if (template_val.includes('collection')) {
        cHtml = document.getElementById('ProductGridContainer');
      } else {
        cHtml = document.getElementById('MainSearchContainer');
      }
      
      if (cHtml) {
        cHtml.innerHTML = text;
      } 

      window.history.pushState(null,"",url);
      this.renderPaginate();
      this.renderFacetsRemove(url);

      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();

      const page_bottom = document.querySelector('.toolbar-bottom');
      let total_count;
      let total_count_element = document.querySelector('.product-total-count');
      let total_count_title_element = document.querySelector(".product-total-title-count");
      let mobile_total = document.querySelector('#ProductCount');

      if (page_bottom) {
        total_count = page_bottom.querySelector('.page-total-count').innerHTML;
        total_count_element.innerHTML = total_count;
        total_count_title_element ? (total_count_title_element.innerHTML = total_count) : null;
        mobile_total.innerHTML = `${total_count} Products`;
      } else {
        const product_items = document.querySelectorAll('.grid-item');
        total_count_element.innerHTML = product_items.length;
        total_count_title_element ? (total_count_title_element.innerHTML = product_items.length) : null;
        mobile_total.innerHTML = `${product_items.length} Products`;
      }
    }).finally(() => {
      document.dispatchEvent(new Event('EXCHANGE-RATES:REFRESH'));
    });
  }

  renderFacetsRemove(url) {
    const facetsContent = document.querySelector('[js-active-facets-content]');

    if (url.split('?').length > 0 && url.split('?')[1]) {
      const facetItems = url.split('?')[1].split('&');

      let total_html = '';
      let total_count = 0;
      facetItems.forEach(item => {
        if (item != '') {
          const param_name = item.split('=')[0];
          const value = item.split('=')[1];
          // if (
          //   param_name != 'sort_by' && 
          //   param_name != 'page' && 
          //   param_name != 'type' && 
          //   param_name != 'q' && 
          //   value != ''
          // )
          if (
            param_name.includes('filter') && 
            value != ''
          ) {
            let val = value.toString().replaceAll('%23', '#').replaceAll('%3A', ':').replaceAll('%26','&').replaceAll('+', ' ');
            let label = value.toString().replaceAll('%23', '#').replaceAll('%3A', ':').replaceAll('%26','&').replaceAll('+', ' ');
            total_count += 1;
            const html = `
              <a class="active-facets__button active-facets__button--light" href="#" js-active-facets data-param="${param_name}" data-value="${val}">
                <span class="active-facets__button-inner button button--tertiary">
                  ${label.includes(':') ? label.split(':')[1] : label}
                  <svg aria-hidden="true" focusable="false" role="presentation" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span class="visually-hidden">Remove filter</span>
                </span>
              </a> 
            `;

            total_html += html;
          }
        }
      });

      if (facetsContent) {
        facetsContent.innerHTML = total_html;
        const removeButton = document.querySelector('.active-facets__button-wrapper');
        
        if (total_count > 0) {
          if (removeButton) removeButton.classList.remove('hidden');
        } else {
          if (removeButton) removeButton.classList.add('hidden');
        }
        this.eventFacetsRemove();
      }
    }
  }

  eventFacetsRemove() {
    const facets_active_items = document.querySelectorAll('[js-active-facets]');
    const clearButton = document.querySelector('[js-all-remove-facets]');
    const cancelButton = document.querySelector('[js-active-cancel]');
    const filterButton = document.querySelector('[js-active-filter]');
    const closeButton = document.querySelector('[js-close-filter-button]');

    this.is_remove_all = false;

    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.renderClearUrl();
        if (facetsForm) facetsForm.classList.remove('active');
      });
    }

    facets_active_items.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        item.remove();

        const param_name = item.getAttribute('data-param');
        const value = item.getAttribute('data-value').toString().replaceAll('#','%23').replaceAll(':', '%3A').replaceAll(' & ', '+%26+').replaceAll(' ','+');

        const url = window.location.href;
        const prefix_url = url.split('?')[0];
        if (url.split('?').length > 0 && url.split('?')[1]) {
          const facetItems = url.split('?')[1].split('&');

          let total_url = '';
      
          facetItems.forEach(facet => {
            if (facet != '') {
              const param = facet.split('=')[0];
              const val = facet.split('=')[1];
    
              if (param_name == param && value == val) {
                console.log('Same parameter!');
              } else {
                total_url += `${param}=${val}&`;
              }
            }
          });

          let result_url = '';
          let template_val = 'collection';
          const template = document.querySelector('.facets-container');
          if (template) template_val = template.getAttribute('data-template');
      
          if (!template_val.includes('collection')) {
            if (!result_url.includes('product=')) {
              result_url += `${prefix_url}?type=product&q=${template.getAttribute('data-search')}&${total_url}`; 
            } else {
              result_url += `${prefix_url}?${total_url}`; 
            }
            
          } else {
            result_url = `${prefix_url}?${total_url}`
          }
          this.renderAjaxHtml(result_url, template_val, param_name, value);
        }
      });
    });

    if (clearButton) {
      clearButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.is_remove_all) {
          this.is_remove_all = true;
          this.renderClearUrl();
        }
      });
    }

    if (filterButton) {
      filterButton.addEventListener('click', (e) => {
        e.preventDefault();

        const mobileForm = document.querySelector('[js-filter-form]');
        if (mobileForm) mobileForm.classList.remove('active');
      });
    }

    if (cancelButton) {
      cancelButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.renderClearUrl();

        const mobileForm = document.querySelector('[js-filter-form]');
        if (mobileForm) mobileForm.classList.remove('active');
      });
    }
    document.dispatchEvent(new Event('EXCHANGE-RATES:REFRESH'));
  }

  renderClearUrl () {
    const facetsContent = document.querySelector('[js-active-facets-content]');
    const url = window.location.href;
    const prefix_url = url.split('?')[0];

    if (facetsContent) {
      facetsContent.innerHTML = '';

      if (url.split('?').length > 0 && url.split('?')[1]) {
        const facetItems = url.split('?')[1].split('&');
  
        let total_url = '';
  
        facetItems.forEach(item => {
          if (item != '') {
            const param_name = item.split('=')[0];
            const value = item.split('=')[1];
  
            if (param_name == 'sort_by' || param_name == 'page') {
              total_url += `${param_name}=${value}&`;
            }
          }
        });

        let result_url = '';
        let template_val = 'collection';
        const template = document.querySelector('.facets-container');
        if (template) template_val = template.getAttribute('data-template');
    
        if (!template_val.includes('collection')) {
          result_url += `${prefix_url}?type=product&q=${template.getAttribute('data-search')}&`; 
        } else {
          result_url = `${prefix_url}?${total_url}`
        }
        this.renderAjaxHtml(result_url, template_val, '', '');
      }
    }
  }

  renderAjaxHtml(result_url, template, param, value) {
    fetch(`${result_url}view=json`).then(res => {
      return res.text();
    }).then(text => {
      window.history.pushState(null,"", `${result_url}`);
      let cHtml = ''
      if (template.includes('collection')) {
        cHtml = document.getElementById('ProductGridContainer');
      } else {
        cHtml = document.getElementById('MainSearchContainer');
      }
      
      if (cHtml) {
        cHtml.innerHTML = text;
      }

      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();

      this.is_remove_all = false;

      const page_bottom = document.querySelector('.toolbar-bottom');
      let total_count;
      let total_count_element = document.querySelector('.product-total-count');
      let total_count_title_element = document.querySelector(".product-total-title-count");
      let mobile_total = document.querySelector('#ProductCount');

      if (page_bottom) {
        total_count = page_bottom.querySelector('.page-total-count').innerHTML;
        total_count_element.innerHTML = total_count;
        total_count_title_element ? (total_count_title_element.innerHTML = total_count) : null;
        mobile_total.innerHTML = `${total_count} Products`;
      } else {
        const product_items = cHtml.querySelectorAll('.grid-item');
        total_count_element.innerHTML = product_items.length;
        total_count_title_element ? (total_count_title_element.innerHTML = product_items.length) : null;
        mobile_total.innerHTML = `${product_items.length} Products`;
      }

      const removeButton = document.querySelector('.active-facets__button-wrapper');
      if (removeButton) removeButton.classList.add('hidden');

      const filterItems = document.querySelectorAll('[js-filter-item]');
      if (param != '' && value != '') {
        filterItems.forEach(facet => {
          if (facet.querySelector('input')) {
            if (facet.querySelector('input').name == param && facet.querySelector('input').value == value) {
              facet.querySelector('input').checked = false;
            }
          }
        });
      } else {
        filterItems.forEach(facet => {
          if (facet.querySelector('input')) {
            facet.querySelector('input').checked = false;
          }
        });
      }

      if (result_url.split('?').length > 0 && result_url.split('?')[1]) {
        const items = result_url.split('?')[1].split('&');
        items.forEach(item => {
          if (item != '') {
            const param_name = item.split('=')[0];
            const val = item.split('=')[1];

            filterItems.forEach(facet => {
              if (facet.querySelector('input')) {
                if (facet.querySelector('input').name == param_name && facet.querySelector('input').value == val) {
                  facet.querySelector('input').checked = true;
                }
              }
            });
          }
        });
      }
      this.renderFacetsRemove(result_url);
      this.eventFacetsRemove();
    });
  }
}



FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
  
class PriceRange extends HTMLElement {
  constructor() {
    super();
    // this.querySelectorAll('input')
    //   .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    //this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
  
customElements.define('price-range', PriceRange);
  
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}
  
customElements.define('facet-remove', FacetRemove);

const sortButton = document.querySelector('[js-mobile-facets-button]');
const facetsForm = document.querySelector('[js-filter-form]');

if (sortButton) {
  sortButton.addEventListener('click', (e) => {
    e.preventDefault();

    if (facetsForm) facetsForm.classList.add('active');
  })
}

